/**
 * GENERATED FILE — DO NOT EDIT.
 *
 * Written by scripts/generate-version.mjs from the "version" field in
 * package.json. Bump the version there; this file follows automatically on
 * `npm run build` / `npm run typecheck`.
 */

/**
 * Version of the plugin-utils package.
 * Can be used at runtime to check compatibility.
 */
export const PLUGIN_UTILS_VERSION = '2.7.1';
